import { APIResponse, APIResponseDtoImpl } from '../apiresponse';
import { AboutDto } from '../../dto/about/aboutdto';

export interface AboutResponse extends APIResponse
{
    getAboutDtos(): AboutDto[];
}

export class AboutResponseDtoImpl extends APIResponseDtoImpl implements AboutResponse
{
    private faqDtos : AboutDto[];

    getAboutDtos(): AboutDto[]
    {
        return this.faqDtos;
    }
    setAboutDtos(faqDtos: AboutDto[])
    {
        this.faqDtos = faqDtos;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/about/aboutresponse.tsx